import { Action, createSlice, PayloadAction, ThunkAction } from '@reduxjs/toolkit';
import { RootState } from 'src/store';
import { HabitatInsightsGeoJson } from 'src/shared/types';

export type AddSiteToPlatformGeoJsonValidationError = {
    type: string;
    message: string;
};

export type AddSiteToPlatformFormState = {
    runCloudJobs: boolean;
    // Basic information
    customerId: string;
    customerName?: string;
    projectId: string;
    portfolioId?: string;
    projectName?: string;
    isHlcaProject?: boolean;
    country?: string;
    // File upload
    uploadedFileContent: string;
    uploadedFileErrors: AddSiteToPlatformGeoJsonValidationError[] | [];
    uploadedFileName: string;
    sites: HabitatInsightsGeoJson[] | [];
    formMode: string;
    loading: boolean;
};

export const defaultAddSiteToPlatformFormState = {
    runCloudJobs: true,
    customerId: '',
    customerName: '',
    projectId: '',
    portfolioId: '',
    projectName: '',
    isHlcaProject: true,
    country: '',
    uploadedFileContent: '',
    uploadedFileErrors: [],
    uploadedFileName: '',
    sites: [],
    formMode: 'create',
    loading: false,
};

export type AddSiteToPlatformFormUIState = {
    formStep: number;
    formState: AddSiteToPlatformFormState;
};

type AddSiteToPlatformState = {
    uiState: AddSiteToPlatformFormUIState;
};

const initialState: AddSiteToPlatformState = {
    uiState: { formStep: 0, formState: { ...defaultAddSiteToPlatformFormState } },
};

export const resetAddSiteToPlatform = (): ThunkAction<void, RootState, void, Action<string>> => dispatch => {
    dispatch(addSiteToPlatformSlice.actions.reset());
};

const addSiteToPlatformSlice = createSlice({
    name: 'addSiteToPlatform',
    initialState,
    reducers: {
        setFormState(state, action: PayloadAction<Partial<AddSiteToPlatformFormState>>) {
            state.uiState.formState = { ...state.uiState.formState, ...action.payload };
        },

        reset(state) {
            // eslint-disable-next-line
            state.uiState = { ...initialState.uiState };
        },
    },
});

export default addSiteToPlatformSlice.reducer;

export const { setFormState, reset } = addSiteToPlatformSlice.actions;
